<template>
  <vue-final-modal
    v-model="showCookiesModal"
    name="cookiesModal"
    classes="modal-container"
    content-class="modal-content"
    :click-to-close="false"
    :lock-scroll="false"
    v-if="getCookiesModalTrans">
    <h1 class="hello">{{getCookiesModalTrans.title}}</h1>
    <p class="advise">{{getCookiesModalTrans.p1}}</p>
    <a class="cookies-link" href="" @click="openCookies">{{getCookiesModalTrans.cookies_policy_link}}</a>
    <hr>
    <h2>{{getCookiesModalTrans.technical_cookies_title}}</h2>
    <p>{{getCookiesModalTrans.p2}}</p>
    <div class="collapse-title" @click="isOpenTech = !isOpenTech">
      <Image
        imageUrl="ico_docu.png"
        altText="Icono lista"
        class="icon"
        :api="false"
      />
      <p>{{getCookiesModalTrans.dropdown}}</p>
      <ChevronUpIcon class="chevron" v-if="isOpenTech" />
      <ChevronDownIcon class="chevron" v-if="!isOpenTech" />
    </div>
    <div class="collapse-content" v-if="isOpenTech">
      <div class="cookie-info">
        <p><b>Cookie</b>isAdult</p>
        <p><b>{{getCookiesModalTrans.name}}</b>concursos.barmanagerapp.com</p>
        <p><b>{{getCookiesModalTrans.ended}}</b>{{getCookiesModalTrans.ended_never}}</p>
        <p><b>{{getCookiesModalTrans.goal}}</b>{{getCookiesModalTrans.isAdult_more_info}}</p>
      </div>
      <div class="cookie-info">
        <p><b>Cookie</b>coockieAgreed</p>
        <p><b>{{getCookiesModalTrans.name}}</b>concursos.barmanagerapp.com</p>
        <p><b>{{getCookiesModalTrans.ended}}</b>{{getCookiesModalTrans.ended_never}}</p>
        <p><b>{{getCookiesModalTrans.goal}}</b>{{getCookiesModalTrans.cookieAgreed_more_info}}</p>
      </div>
      <div class="cookie-info">
        <p><b>Cookie</b>session</p>
        <p><b>{{getCookiesModalTrans.name}}</b>concursos.barmanagerapp.com</p>
        <p><b>{{getCookiesModalTrans.ended}}</b>{{getCookiesModalTrans.ended_never}}</p>
        <p><b>{{getCookiesModalTrans.goal}}</b>{{getCookiesModalTrans.session_more_info}}</p>
      </div>
    </div>
    <button class="btn-cookies-black" @click="saveMyConfig">{{getCookiesModalTrans.store_config}}</button>
    <button class="btn-cookies-green" @click="acceptAll">{{getCookiesModalTrans.accept_all}}</button>
  </vue-final-modal>
</template>

<script>
import Image from '@/components/Image.vue'
import ChevronUpIcon from '@/components/ChevronUpIcon.vue'
import ChevronDownIcon from '@/components/ChevronDownIcon.vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CookiesModal',
  data () {
    return {
      showCookiesModal: false,
      isOpenTech: false
    }
  },
  components: {
    Image,
    ChevronUpIcon,
    ChevronDownIcon
  },
  computed: {
    ...mapGetters(['getCookiesModalTrans'])
  },
  methods: {
    ...mapMutations(['setCookies']),
    openCookiesModal () {
      this.$vfm.show('cookiesModal')
    },
    saveMyConfig () {
      localStorage.setItem('coockieAgreed', true)
      this.setCookies(true)
      this.$vfm.hide('cookiesModal')
    },
    acceptAll () {
      localStorage.setItem('coockieAgreed', true)
      this.setCookies(true)
      this.$vfm.hide('cookiesModal')
    },
    openCookies () {
      window.open(`https://participa.barmanagerapp.com/keler/#/${this.$route.params.alias_url}/cookies_policy`, '_blank')
    }
  }
}
</script>

<style scoped>
:deep(.modal-container) {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  height: 100%;
  margin-top: auto;
  margin-bottom: auto;
  overflow-y: auto;
  padding: 1rem;
  top: auto;
  left: auto;
  right: auto;
  bottom: auto;
  width: 100%;
}
:deep(.modal-content) {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.75rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  margin-top: auto;
  margin-bottom: auto;
  max-width: 600px;
  padding: 2rem;
}
:deep(.modal-content h1) {
  font-weight: 700;
  font-size: 1.125rem;
  line-height: 1.75rem;
  text-align: left;
}
:deep(.modal-content h2) {
  font-weight: 700;
  font-size: 1.125rem;
  line-height: 1.75rem;
  text-align: left;
}
:deep(.modal-content p) {
  font-size: 0.875rem;
  line-height: 1.25rem;
  text-align: left;
}
:deep(.modal-content a) {
  display: inline;
  -webkit-text-decoration-line: underline;
  text-decoration-line: underline;
}
:deep(.modal-content hr) {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
:deep(.modal-content .collapse-title) {
  border-bottom-width: 1px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
}
:deep(.modal-content .collapse-title):hover {
  cursor: pointer;
}
:deep(.modal-content .collapse-title .icon) {
  height: 20px;
  width: 20px;
}
:deep(.modal-content .collapse-title p) {
  margin-left: 0.5rem;
}
:deep(.modal-content .collapse-title .icon img) {
  height: 20px;
}
:deep(.modal-content .collapse-title .chevron) {
  margin-left: auto;
}
:deep(.modal-content .collapse-content) {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 182, 109, var(--tw-bg-opacity));
  --tw-bg-opacity: 0.1;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
:deep(.modal-content .collapse-content .cookie-info) {
  border-bottom-width: 1px;
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
}
:deep(.modal-content .collapse-content .cookie-info b) {
  margin-right: 0.5rem;
}
:deep(.modal-content .btn-cookies-black) {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
  font-weight: 700;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  width: 100%;
}
:deep(.modal-content .btn-cookies-black):hover {
  opacity: 0.8;
}
:deep(.modal-content .btn-cookies-green):hover {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 182, 109, var(--tw-bg-opacity));
  --tw-bg-opacity: 0.1;
  --tw-border-opacity: 1;
  border-color: rgba(0, 182, 109, var(--tw-border-opacity));
}
:deep(.modal-content .btn-cookies-green) {
  --tw-border-opacity: 1;
  border-color: rgba(0, 0, 0, var(--tw-border-opacity));
  border-width: 1px;
  font-weight: 700;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  width: 100%;
}
</style>
